import React from 'react';
import { ButtonProps } from 'antd';

type ButtonOverlayDialogProps = {
    visible: boolean;
    onCancel: (...args: any) => void;
    onSuccess: (...args: any) => void;
};
type ButtonWithOverlayDialogProps = {
    button: React.ReactElement<ButtonProps>;
    overlay: React.ReactElement<ButtonOverlayDialogProps>;
    destroyOnClose?: boolean;
};
export default function ButtonWithOverlayDialog({
    overlay,
    button,
    destroyOnClose = true,
    ...rest
}: ButtonWithOverlayDialogProps) {
    const [visible, setVisible] = React.useState(false);
    const handleClick = (e: any) => {
        setVisible(true);
        button.props?.onClick?.(e);
    };
    const handleCancel = (...args: any) => {
        setVisible(false);
        overlay.props?.onCancel?.(...args);
    };
    const handleSuccess = (...args: any) => {
        setVisible(false);
        overlay.props?.onSuccess?.(...args);
    };
    const buttonRender = React.cloneElement(button, {
        ...button.props,
        onClick: handleClick,
    });

    return (
        <>
            {buttonRender}
            {(!destroyOnClose || (destroyOnClose && visible)) &&
                React.cloneElement(overlay, {
                    ...overlay.props,
                    onSuccess: handleSuccess,
                    onCancel: handleCancel,
                    visible,
                })}
        </>
    );
}
